import React from "react";
import {
  View,
  Image,
  ImageBackground,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
} from "react-native";
import { Surface, ActivityIndicator } from "react-native-paper";
import { connect } from "react-redux";
import {
  getAppTermsAndConditions,
  clearAppTermsAndConditionsData,
} from "./../../store/actions";
// import BackHandlerAndroid from './../AndroidBackHandler';
// import HTML from "react-native-render-html";
// import LinearGradientComponent from './../HeaderBackgroundComponent';
// import StylesColors from './../Colors';
// import OfflineHandler from './../OfflineHandler';
import { Styles, Text } from './../../components/UI-Components';
// import AdsScreen from "./../Ads"
import Header from "./../../components/Header";


class AppTermsAndConditionsScreen extends React.Component {
  state = {
    // any thing can write here
  };

  // static navigationOptions = ({ navigation }) => {
  //     return {
  //         headerTitle: 'TERMS & CONDITIONS',
  //         headerBackground:
  //         ( <LinearGradientComponent />),
  //         headerStyle: {
  //             justifyContent: 'center',
  //             alignItems: 'center',
  //             color: StylesColors.headerTextColor,
  //             fontWeight: StylesColors.headerTextFontWeight,
  //             elevation: 0,
  //         },
  //         headerTintColor: StylesColors.headerTintColor,
  //         headerTitleStyle: {
  //             color: StylesColors.headerTextColor,
  //             alignSelf: 'center',
  //             // width: '90%',
  //             textAlign: 'center',
  //             fontWeight: StylesColors.headerTextFontWeight,
  //             elevation: 0,
  //         },
  //     }
  // }

  componentDidMount() {
    this.props.getAppTermsAndConditions();
  }

  isAd = () => {
    this.setState({
      isAdShow: true,
    });
  };

  render() {
    return (
      <>
       
             <Header
            title="Terms And Conditions"
            // headerRight
            
            />
        <div
          // style={{
          //   flex: 1,
          //   backgroundColor: Styles.white,
          //   height: "90vh",
          //   elevation: 4,
          //   paddingVertical: 30,
          // }}
          className={`${this.props.loading? "conditions" : 'full-height'} `}

        >
          {/* <View style={{backgroundColor: Styles.white}}> */}
          {!this.props._termsAndConditions && (
            <View
              style={{
                height: "100%",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ActivityIndicator />
            </View>
          )}
          <ScrollView
            style={{
              paddingHorizontal: 8,
              textAlign: "justify",
              paddingBottom: 50,
              flex: 1,
              marginBottom: 10,
            }}
          >
            {/* <View style={{marginTop:10,marginHorizontal:15,paddingBottom: this.state.isAdShow ? 60 : 0}}> */}
            {this.props._termsAndConditions &&
              this.props._termsAndConditions.length > 0 && (
                // <HTML tagsStyles={{h3:{fontWeight:'700',marginVertical:5,textAlign:'justify',fontFamily:Styles.primaryFontFamily},p:{fontWeight:'400',marginVertical:2,textAlign:'justify',fontFamily:Styles.primaryFontFamily}}} html={this.props._termsAndConditions } />
                <div
                  style={{ flex: 1 }}
                  dangerouslySetInnerHTML={{
                    __html: this.props._termsAndConditions,
                  }}
                ></div>
              )}
            {/* </View> */}
          </ScrollView>
          {/* </View> */}
          {/* {
                this.props._termsAndConditions &&
            <AdsScreen screenName={"AppTermsAndConditionsScreen"}  isAdCallBack={this.isAd}/>
         } */}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  loading:
    state.appTestAndTermsConditions &&
    state.appTestAndTermsConditions.loading &&
    state.appTestAndTermsConditions.loading,
  error:
    state.appTestAndTermsConditions &&
    state.appTestAndTermsConditions.error &&
    state.appTestAndTermsConditions.error,
  errorInfo:
    state.appTestAndTermsConditions &&
    state.appTestAndTermsConditions.errorInfo &&
    state.appTestAndTermsConditions.errorInfo,
  _termsAndConditions:
    state.appTestAndTermsConditions &&
    state.appTestAndTermsConditions.response &&
    state.appTestAndTermsConditions.response.terms_and_conditions,
});

export default connect(mapStateToProps, {
  getAppTermsAndConditions,
  clearAppTermsAndConditionsData,
})(AppTermsAndConditionsScreen);
